"use client";

import Link from "next/link";
import React from "react";
import {
  OakBox,
  OakFlex,
  OakGrid,
  OakGridArea,
  OakHandDrawnHR,
  OakHeading,
  OakPupilJourneyYearButton,
} from "@oaknational/oak-components";

import type { Year } from "@/types/ui";

type Props = {
  years: Year[];
  subjectsUrlTemplate: string;
  onYearSelected?: (year: Year) => void;
};
export const GoogleClassroomBrowseView = ({
  years,
  subjectsUrlTemplate,
  onYearSelected,
}: Props) => {
  return (
    <OakFlex
      $flexDirection="column"
      $minHeight={"100vh"}
      $flexGrow={1}
      $background={"mint"}
      $alignItems={"center"}
      $justifyContent={"center"}
    >
      <OakFlex $pv={["spacing-32", "spacing-48", "spacing-56"]}>
        <OakFlex
          $background={"bg-primary"}
          $pv={["spacing-16", "spacing-32", "spacing-48"]}
          $ph={["spacing-10", "spacing-16", "spacing-24"]}
          $flexDirection={"column"}
          $alignItems={"center"}
          $borderRadius={"border-radius-l"}
          $ba={"border-solid-s"}
          $borderColor={"border-decorative1-stronger"}
        >
          <OakFlex $ph={"spacing-24"} $flexDirection={"column"}>
            <OakFlex
              $flexDirection={"column"}
              $gap={"spacing-16"}
              $mb={["spacing-16", "spacing-24", "spacing-32"]}
            >
              <OakHeading tag="h1" $font={"heading-7"}>
                Welcome to Oak
              </OakHeading>
              <OakHeading
                tag="h1"
                $font={["heading-5", "heading-5", "heading-4"]}
              >
                Add Oak lessons to your assignments
              </OakHeading>
            </OakFlex>

            <OakHandDrawnHR
              hrColor={"border-neutral-lighter"}
              $width={"100%"}
              aria-hidden="true"
            />
            <OakHeading
              tag="h3"
              $font={"heading-7"}
              $mv={["spacing-24", "spacing-32", "spacing-32"]}
            >
              View subjects by year
            </OakHeading>
            <OakGrid
              role="list"
              $cg={"spacing-16"}
              $rg={"spacing-16"}
              $gridTemplateColumns={[
                "repeat(2 , 1fr)",
                "repeat(4 , 1fr)",
                "repeat(6 , 1fr)",
              ]}
            >
              {years.map((year) => {
                return (
                  <OakGridArea $colSpan={1} key={year.yearSlug} role="listitem">
                    <OakPupilJourneyYearButton
                      element={Link}
                      href={subjectsUrlTemplate.replace(
                        ":yearSlug",
                        year.yearSlug,
                      )}
                      prefetch={true}
                      phase={year.phase}
                      onClick={() => {
                        onYearSelected?.(year);
                      }}
                      width={"100%"}
                    >
                      <OakBox
                        $minWidth={["auto", "spacing-80", "spacing-80"]}
                        $mh={["spacing-4", "auto", "auto"]}
                        $textAlign={"center"}
                      >
                        {year.yearDescription}
                      </OakBox>
                    </OakPupilJourneyYearButton>
                  </OakGridArea>
                );
              })}
            </OakGrid>
          </OakFlex>
        </OakFlex>
      </OakFlex>
    </OakFlex>
  );
};
